<template>
    <div>
        <modal
            class="modal alert"
            v-if="showAlert"
            :show.sync="showAlert"
            headerClasses="justify-content-center"
            ><div class="modalText">Are you sure to delete this Result Chain?</div>
            <!-- <br /> -->
            <base-button
                @click="deleteResultChain()"
                class="alert__button"
                type="info"
                >Yes</base-button
            >&nbsp;
            <base-button
                @click="showAlert = false"
                type="warning"
                class="alert__button"
                >No</base-button
            >
            <div class="errorAlert">
                {{ deleteAlertText }}
            </div>
        </modal>

        <modal
            class="modal"
            v-if="showForm"
            :show.sync="showForm"
            headerClasses="justify-content-center"
        >
            <h3 v-if="!isUpdate" class="modalHeader">Add Result Chain</h3>
            <h3 v-if="isUpdate" class="modalHeader">Update Result Chain</h3>
            <div class="form">
                <!-- <el-form
                ref="form"
                :model="form"
                label-width="120px"
                class="form"
                style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    padding: 0px;
                "
            > -->
                <table>
                    <tr>
                        <td class="label">
                            <!-- <div class="input"> -->
                            Type :
                        </td>
                        <td class="formInput">
                            <el-select
                                v-model="form.type"
                                placeholder="Select Result Chain Type"
                                class="select__field field"
                                :disabled="isUpdate"
                            >
                                <el-option
                                    v-for="item in resultChainTypes"
                                    :key="item.id"
                                    :label="item.type"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </td>
                        <!-- </div> -->
                    </tr>
                    <tr>
                        <td class="label" valign="top">
                            <!-- <div class="input" style="align-items: flex-start"> -->
                            Result Chain :
                        </td>
                        <td class="formInput">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 3, maxRows: 10 }"
                                placeholder="Result Chain"
                                v-model="form.resultChain"
                                class="field resultChainField"
                            >
                            </el-input>
                        </td>
                        <!-- </div> -->
                    </tr>

                    <tr>
                        <!-- <td></td> -->
                        <td>
                            <div
                                class="resultChainButton"
                                style="
                                    width: 100%;
                                    justify-content: flex-end;
                                    padding-top: 10px;
                                "
                            >
                                <base-button
                                    @click="addResultChain()"
                                    type="info"
                                    v-if="!isUpdate"
                                    class="buttons"
                                    >Submit</base-button
                                >
                                <base-button
                                    @click="updateResultChain()"
                                    type="info"
                                    v-if="isUpdate"
                                    class="buttons"
                                    >Update</base-button
                                >
                                <!-- <base-button
                        size="sm"
                        type="primary"
                        @click="handleClear()"
                        class="buttons"
                        ><i class="el-icon-close"></i>Clear</base-button
                    > -->
                            </div>
                        </td>
                        <td></td>
                    </tr>
                </table>
                <div class="errorAlert">{{ baseAlertText }}</div>
            </div>
        </modal>
        <!-- </el-form> -->
        <div class="addIndicatorWrapper">
            <base-button
                @click="openModal()"
                type="primary"
                class="addIndicatorBtn"
                ><i class="el-icon-plus"></i>Add Result Chain</base-button
            >
        </div>
        <div class="table">
            <el-table :data="tableData" style="width: 100%" class="table">
                <el-table-column
                    prop="type"
                    label="Type"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="resultChain"
                    label="Result Chain"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column label="" class="table__column">
                    <template slot-scope="scope">
                        <!-- <i
                    class="el-icon-edit"
                        @click="handleEdit(scope.$index, scope.row)"
                        style="color:blue;font-size:larger;"
                        ></i> -->
                        <base-button
                            size="sm"
                            type="info"
                            @click="handleEdit(scope.$index, scope.row)"
                            class="table__button"
                            >Edit<i class="el-icon-edit"></i
                        ></base-button>
                        <base-button
                            size="sm"
                            type="warning"
                            @click="handleDelete(scope.$index, scope.row)"
                            class="table__button"
                            >Delete<i class="el-icon-delete"></i
                        ></base-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.modalText {
    color: #525f7f;
}
// .form {
//     display: flex;
//     flex-direction: column;
//     justify-content: flex-start;
//     align-items: center;
//     padding: 30px;
//     width: max-content;
//     .input {
//         display: flex;
//         align-items: center;

//         .field {
//             width: 343px;
//             padding: 10px;
//         }
//         .resultChainField {
//             align-items: flex-start !important;
//             padding-left: 10px;
//             width: 343px;
//             // width: 270px;
//         }
//         .resultChainButton {
//             // style="
//             // width: 100%;
//             // display: flex;
//             // justify-content: flex-end;
//             // padding: 5px;
//             // padding-top: 10px;
//             // "
//             .buttons {
//                 padding: 20px;
//             }
//         }
//     }
// }
.modalHeader{
    margin-bottom: 20px;
}
.form {
    padding: 10px;
    .label {
        // display: flex;
        // justify-content: flex-end;
        // padding: 10px;
        display:flex;
        text-align: right;
        width: max-content;
        // margin-top: 10px;
    }

    .formInput {
        display: flex;
        justify-content: flex-start;
        // padding-left: 10px;
        // margin-top: 10px;
        // width: max-content;
    }
    .field {
        width: 343px;
    }
    // .resultChainField {
    // }
    .resultChainButton {
        .buttons {
        }
    }
}
.table {
    margin-top: 10px;
    &__button {
        margin: 20px !important;
    }
    &__column {
        text-align: center !important;
    }
}
//
.addIndicatorWrapper {
    padding: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .addIndicatorBtn {
        transform: translateY(-3px);
        color: #90c14f;
        background: #f5f6fa !important;
    }
}
.errorAlert {
    color: red;
}
</style>
<script>
import {
    LogMonitoringService,
    GrantService,
    ApplicationService,
    CallService,
} from "@/services";
import { Table, TableColumn, Select, Option } from "element-ui";
import { Modal } from "src/components";
export default {
    name: "Result-Chain",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        // Pagination
    },
    data() {
        return {
            form: {
                type: "",
                resultChain: "",
                id: "",
            },
            showAlert: false,
            isUpdate: false,
            showForm: false,
            tableData: [],
            baseAlertText: "",
            deleteAlertText: "",
            applicationsList: [],
            resultChainTypes: [],
            deleteID: "",
        };
    },
    methods: {
        openModal() {
            this.handleClear();
            this.showForm = !this.showForm;
            this.isUpdate = false;
            this.baseAlertText = "";
        },
        handleClear() {
            const clearedForm = {
                id: "",
                type: "",
                resultChain: "",
            };
            this.form = clearedForm;
            this.isUpdate = false;
            this.getAllResultChains();
        },
        async getResultChainTypes() {
            await LogMonitoringService.getResultChainTypes().then(
                (response) => {
                    this.resultChainTypes = response.data.data;
                }
            );
        },
        async getAllResultChains() {
            await LogMonitoringService.getAllResultChains().then((response) => {
                this.tableData = response.data.data;
            });
        },
        async handleEdit(index, row) {
            console.log("Index : ", index);
            console.log("Row : ", row);
            this.baseAlertText = "";

            // await LogMonitoringService.getIndicator(row.id).then((response) => {
            //     this.getIndicators();
            //     console.log(response);
            this.form.type = row.typeId;
            this.form.resultChain = row.resultChain;
            this.form.id = row.id;
            // this.form.type = response.data.data.id;
            // this.form.resultChain = response.data.data.indicatorCode;

            this.isUpdate = true;
            this.showForm = true;
            // });
        },
        async updateResultChain() {
            if(this.form.type==""||this.form.resultChain==""){
                this.baseAlertText="Please input all the fields before submitting";
                return;
            }
            await LogMonitoringService.updateResultChain({
                id: this.form.id,
                type_id: this.form.type,
                result_chain: this.form.resultChain,
            }).then((response) => {
                if (response.error) {
                    this.baseAlertText = response.error;
                    this.showBaseAlert = true;
                }
                this.handleClear();
                this.showForm = false;
                this.isUpdate = false;
                this.getAllResultChains();
                console.log("Updated indicator");
            });
        },
        async handleDelete(index, row) {
            this.deleteID = row.id;
            this.showAlert = true;
            this.deleteAlertText = "";
        },
        async deleteResultChain() {
            await LogMonitoringService.deleteResultChain({
                id: this.deleteID,
            }).then((response) => {
                console.log("Deleted, I believe");
                if (
                    response.data.warning ===
                    "This result chain used in an indicator, cannot be deleted."
                ) {
                    this.deleteAlertText =
                        "This result chain is used in an indicator and cannot be deleted.";
                } else {
                    console.log(response);
                    this.showAlert = false;
                    this.getAllResultChains();
                }
            });
        },
        async addResultChain() {
            if(this.form.type==""||this.form.resultChain==""){
                this.baseAlertText="Please input all the fields before submitting";
                return;
            }
            await LogMonitoringService.addResultChain({
                type_id: this.form.type,
                result_chain: this.form.resultChain,
            })
                .then((response) => {
                    console.log("Result Chain Added");
                    console.log("Response error :", response.error);
                    if (response.error) {
                        this.baseAlertText = response.data.data.error;
                        return;
                    }
                    this.getAllResultChains();
                    this.handleClear();
                    this.showForm = false;
                })
                .catch((error) => {
                    console.log("Response error :", error);
                    this.baseAlertText = error.data.error;
                });
        },
    },
    mounted() {
        this.getResultChainTypes();
        this.getAllResultChains();
    },
};
</script>
